import { patientsRequests } from "./patientsRequests";

export default patientsRequests;
